export const LOGIN_TYPES = {
  DISCORD: 'discord',
  FACEBOOK: 'facebook',
  GOOGLE: 'google'
}

export const NOTIFICATION_REFERENCE = 'nft_notifications/:userID/messages'
export const SUPPORT_EMAIL = 'wallet.support@now.gg'
export const TERMS_OF_USE_URL = 'https://now.gg/terms-and-privacy.html#terms'
export const PRIVACY_POLICY_URL = 'https://now.gg/terms-and-privacy.html#privacy'